module.exports = __webpack_public_path__ + "static/media/EditClass.0227cea7.svg";